<template>
  <div :class="['body-html-'+device]">
    <HeaderVue />
      <router-view class="main"></router-view><!--name省略表示name='default'-->
      <ServiceVue />
    <FooterVue />
  </div>
</template>

<script>

import ResizeMixin from './mixin/ResizeHandler'

import { mapState } from 'vuex'
export default {
  mixins: [ResizeMixin],
  name: 'layOut',
  data() {
    return {

    }
  },
  watch:{
    device:{
      handler:function(data){
        console.log(data,'data==')
      }
    }
  },
  computed:{
    ...mapState({
      device: state => state.app.device
    }),
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.body-html-desktop{
  .main {
    width: 100%;
    min-height: 100vh;
    padding-top: 100px;
    box-sizing: border-box;
  }
}
.body-html-mobile{
  .main{
    // padding-top: 1rem;
  }
}
</style>